import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { checkBoxColor } from '../../../utils';

import styles from './logDetails.module.scss';

const LogItemsCard = ({ name, value, status }) => {
  return (
    <div className={styles.details}>
      <span className={styles.name}>{name}</span>
      <span
        className={cn(styles.value)}
        style={{ color: checkBoxColor(status) }}
      >
        {value}
      </span>
    </div>
  );
};

LogItemsCard.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  status: PropTypes.string,
};

export default LogItemsCard;
